import React, { useState, useEffect } from 'react'
import Navbar from './Navbar'
import Dropdown from './Dropdown'
import LineChart from './LineChart'
import Table from './Table'
import { Link, Navigate } from 'react-router-dom'
import { app } from '../firebaseConfig'
import { getDatabase, ref, onValue, push, child, update } from 'firebase/database'
import Cookies from 'js-cookie'
import MultiSelectDropDown from './MultiSelectDropDown'
import ReactDatePicker from 'react-datepicker'
import DatePicker from "react-datepicker";
import DateRangePicker from './DateRangePicker'
import BarGraph from './BarGraph'
const Performance = () => {
    const [data, setData] = useState({});
    const [profileData, setProfileData] = useState([]);
    const [loading, setLoading] = useState(true);
    const db = getDatabase(app);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [internalEndDate, setInternalEndDate] = useState("");
    const [journeyType, setJourneyType] = useState("");
    const [maneuverTypeArray, setManeuverTypeArray] = useState([]);
    const [journeyTypeArr, setJourneyTypeArr] = useState([]);
    // let maneuverData = [];
    const [maneuverData, setManeuverData] = useState([]);
    const [maneuverDropdownArr, setManeuverDropdownArr] = useState([]);
    const [barGraphJourneyObject, setBarGraphJourneyobject] = useState({});
    const [latestScores, setLatestScores] = useState({});
    const [latestFiveScores, setLatestFiveScores] = useState([]);
    const [seriesData, setSeriesData] = useState([]);
    const [searchState, setSerachState] = useState(false);
    const [prevSeriesData, setPrevSeriesData] = useState([]);
    const [isDropDownOpen, setIsDropDownOpen] = useState(false);

    let maneuverScoreArray = [];
    let categories = [1, 2, 3, 4, 5];
    // console.log("Printing original data ", data);
    // console.log("printing maneuver data array ", maneuverData);
    maneuverDropdownArr.map((item) => {
        maneuverScoreArray.push({
            maneuverName: item,
            score: 0
        })
    })

    const chooseEndDate = (date) => {
        setEndDate(date.getTime());
        setInternalEndDate(date.getTime() + 24 * 60 * 60 * 1000);
    }

    // console.log("Start Date ", startDate);
    // console.log("End Date ", endDate);

    // console.log("Printing bar graph array object ", barGraphJourneyObject);

    // console.log("Printing maneuver Data ", maneuverData);

    const filteredData = (maneuverType) => {
        let filteredJourneys;
        if (data && Object.keys(data).length > 0) {

            if (startDate && internalEndDate && journeyType) {
                // console.log("Enter in first condition", startDate, endDate, journeyType)
                filteredJourneys = Object.values(data.journeys).filter(journey => (
                    journey.startDate >= startDate &&
                    journey.endDate <= internalEndDate &&
                    journey.journeyType === journeyType &&
                    journey.maneuverMeta.some(maneuver => maneuver.name === maneuverType)
                ))
            }
            else if (startDate && internalEndDate && !journeyType) {
                // console.log("Enter in second condition")
                filteredJourneys = Object.values(data.journeys).filter(journey => (
                    journey.startDate >= startDate &&
                    journey.endDate <= internalEndDate &&
                    journey.maneuverMeta.some(maneuver => maneuver.name === maneuverType)
                ))
            }
            else if (!startDate && !internalEndDate && journeyType) {
                // console.log("Enter third condition")
                filteredJourneys = Object.values(data.journeys).filter(journey => (
                    journey.journeyType === journeyType &&
                    journey.maneuverMeta.some(maneuver => maneuver.name === maneuverType)
                ))
            }
            else {
                // console.log("Enter in last condition", maneuverType, "  ", data)
                filteredJourneys = Object.values(data.journeys).filter(journey => (
                    journey.maneuverMeta.some(maneuver => maneuver.name === maneuverType)
                ))
            }
            // console.log("filtered journey ", filteredJourneys);
        }
        return filteredJourneys;
    }


    const handleSearch = () => {
        setIsDropDownOpen(false);
        if (startDate && internalEndDate && startDate > internalEndDate) {
            window.alert("Please select valid start and end date");
        }
        else {
            const bargraphArrayFunction = () => {
                const tempManeuverData = [];
                const latestScoresObject = {};
                maneuverScoreArray = [];

                // console.log("Printing maneuver drop down array ", maneuverDropdownArr);
                // Iterate over each maneuver type
                if (maneuverDropdownArr.length > 0) {
                    const tempData = []
                    maneuverDropdownArr.forEach(maneuverType => {
                        console.log("Filtered journey part ", maneuverType);
                        // Filter journeys based on start date, end date, and maneuver type
                        let filteredJourneys;
                        // Sort filtered journeys based on start date in descending order
                        filteredJourneys = filteredData(maneuverType);
                        filteredJourneys.forEach((item) => {
                            let obj = {};
                            obj.maneuverMeta = item.maneuverMeta.filter((item) => {
                                return item.name === maneuverType
                            });
                            const startDate = new Date(item.startDate);
                            // console.log("Date Value ", startDate);
                            obj.startDate = startDate
                            // console.log("New Object ", obj);
                            tempData.push(obj);
                        })
                        console.log("Printing temp Data " , tempData);
                        setManeuverData(tempData);
                        filteredJourneys.sort((a, b) => b.startDate - a.startDate);
                        console.log("Filtered Journey ", filteredJourneys);


                        setManeuverData(tempData);

                        // Get the latest journey (first one after sorting)
                        const latestJourney = filteredJourneys[0];

                        // console.log("Latest Journey ", latestJourney);

                        // Initialize an array to store scores for the current maneuver type
                        const scores = [];

                        // Iterate over maneuver meta of the latest journey
                        latestJourney?.maneuverMeta.forEach(maneuver => {
                            // Check if the maneuver type matches the specified maneuverType
                            if (maneuver.name === maneuverType) {
                                // Push the score to the scores array
                                maneuverScoreArray.push({ maneuverType: maneuverType, score: maneuver.quality.score ? maneuver.quality.score?.toFixed(2) : 0 });
                            }
                        });

                        // Add the maneuver type and its latest score to the latestScores object
                        // maneuverScoreArray.push(scores);
                        latestScoresObject[maneuverType] = scores;
                        // console.log("Scores ", scores);

                    });
                }
                else {
                    const tempData = []
                    maneuverTypeArray.forEach(maneuverType => {
                        console.log("Filtered journey part ", maneuverType);
                        // Filter journeys based on start date, end date, and maneuver type
                        let filteredJourneys;
                        // Sort filtered journeys based on start date in descending order
                        filteredJourneys = filteredData(maneuverType);
                        filteredJourneys.forEach((item) => {
                            let obj = {};
                            obj.maneuverMeta = item.maneuverMeta.filter((item) => {
                                return item.name === maneuverType
                            });
                            const startDate = new Date(item.startDate);
                            // console.log("Date Value ", startDate);
                            obj.startDate = startDate
                            // console.log("New Object ", obj);
                            tempData.push(obj);
                        })
                        console.log("Printing temp Data " , tempData);
                        setManeuverData(tempData);
                        filteredJourneys.sort((a, b) => b.startDate - a.startDate);
                        console.log("Filtered Journey ", filteredJourneys);

                        // Get the latest journey (first one after sorting)
                        const latestJourney = filteredJourneys[0];

                        // console.log("Latest Journey ", latestJourney);

                        // Initialize an array to store scores for the current maneuver type
                        const scores = [];

                        // Iterate over maneuver meta of the latest journey
                        latestJourney?.maneuverMeta.forEach(maneuver => {
                            // Check if the maneuver type matches the specified maneuverType
                            if (maneuver.name === maneuverType) {
                                // Push the score to the scores array
                                maneuverScoreArray.push({ maneuverType: maneuverType, score: maneuver.quality.score ? maneuver.quality.score?.toFixed(2) : 0 });
                            }
                        });

                        // Add the maneuver type and its latest score to the latestScores object
                        // maneuverScoreArray.push(scores);
                        latestScoresObject[maneuverType] = scores;
                        // console.log("Scores ", scores);

                    });
                }

                // Set the latest scores state
                setLatestScores(latestScoresObject);
                // console.log("maneuver Score Array ", maneuverScoreArray);
                let maneuverNameArr = [];
                let maneuverScoreArr = [];

                maneuverScoreArray.map((maneuver) => {
                    maneuverNameArr.push(maneuver.maneuverType);
                    maneuverScoreArr.push(maneuver.score);
                })

                setBarGraphJourneyobject({
                    name: journeyType,
                    categories: maneuverNameArr,
                    data: maneuverScoreArr
                })
                // console.log("Printing maneuver score and maneuver type arr ", maneuverNameArr, " ", maneuverScoreArr);

                // console.log("Latest Score Object ", latestScoresObject);
            }
            const lineChartArrayFunction = () => {
                const latestScoresObject = {};
                setSeriesData([]);
                maneuverScoreArray = [];
                // Iterate over each maneuver type
                if (maneuverDropdownArr.length > 0) {
                    maneuverDropdownArr.forEach(maneuverType => {
                        // Filter journeys based on start date, end date, and maneuver type
                        let filteredJourneys;
                        // Sort filtered journeys based on start date in descending order
                        filteredJourneys = filteredData(maneuverType);
                        filteredJourneys?.sort((a, b) => b.startDate - a.startDate);
                        // console.log("Filtered journey of line chart ", filteredJourneys);
                        // Get the latest journey (first one after sorting)
                        const latestJourney = filteredJourneys?.slice(0, 5).sort((a, b) => a.startDate - b.startDate);

                        // console.log("Latest Journey five ", maneuverType, " ", latestJourney);

                        // Initialize an array to store scores for the current maneuver type
                        const scores = [];

                        // Iterate over maneuver meta of the latest journey
                        if (latestJourney && latestJourney.length > 0) {
                            // console.log("i am saurabh ", latestJourney.maneuverMeta)
                            latestJourney?.map((item) => {
                                item.maneuverMeta.forEach(maneuver => {
                                    if (maneuver.name === maneuverType) {
                                        maneuverScoreArray.push({ maneuverType: maneuverType, score: maneuver.quality.score ? maneuver.quality.score?.toFixed(2) : 0 });
                                    }
                                })
                            })
                        }

                        let seriesData = [];

                        const maneuverScores = {};

                        // Iterate through the maneuvers array
                        for (const maneuver of maneuverScoreArray) {
                            const { maneuverType, score } = maneuver;

                            // Check if the maneuverType already exists as a key in the maneuverScores object
                            if (maneuverScores[maneuverType]) {
                                // If it exists, push the score to the corresponding array
                                maneuverScores[maneuverType].push(parseFloat(score));
                            } else {
                                // If it doesn't exist, create a new array with the score as its first element
                                maneuverScores[maneuverType] = [parseFloat(score)];
                            }
                        }

                        // console.log("Latest five score ", latestScores);

                        Object.entries(maneuverScores).forEach(([key, value]) => {
                            // if (value.length < 5) {
                            //     let tempLength = 5 - value.length;
                            //     while (tempLength > 0) {
                            //         value.push(0);
                            //         tempLength--;
                            //     }
                            // }
                            seriesData.push({
                                name: key,
                                data: value
                            })
                        })
                        // seriesData = seriesData.sort((a, b) => a.startDate - b.startDate)
                        // console.log("Printing series data ", seriesData);
                        setSeriesData(seriesData);
                    });
                }
                else {
                    maneuverTypeArray.forEach(maneuverType => {
                        // Filter journeys based on start date, end date, and maneuver type
                        let filteredJourneys;
                        // Sort filtered journeys based on start date in descending order
                        filteredJourneys = filteredData(maneuverType);
                        filteredJourneys?.sort((a, b) => b.startDate - a.startDate);
                        // console.log("Filtered journey of line chart ", filteredJourneys);
                        // Get the latest journey (first one after sorting)
                        const latestJourney = filteredJourneys?.slice(0, 5).sort((a, b) => a.startDate - b.startDate);

                        // console.log("Latest Journey five ", maneuverType, " ", latestJourney);

                        // Initialize an array to store scores for the current maneuver type
                        const scores = [];

                        // Iterate over maneuver meta of the latest journey
                        if (latestJourney && latestJourney.length > 0) {
                            // console.log("i am saurabh ", latestJourney.maneuverMeta)
                            latestJourney?.map((item) => {
                                item.maneuverMeta.forEach(maneuver => {
                                    if (maneuver.name === maneuverType) {
                                        maneuverScoreArray.push({ maneuverType: maneuverType, score: maneuver.quality.score ? maneuver.quality.score?.toFixed(2) : 0 });
                                    }
                                })
                            })
                        }

                        let seriesData = [];

                        const maneuverScores = {};

                        // Iterate through the maneuvers array
                        for (const maneuver of maneuverScoreArray) {
                            const { maneuverType, score } = maneuver;

                            // Check if the maneuverType already exists as a key in the maneuverScores object
                            if (maneuverScores[maneuverType]) {
                                // If it exists, push the score to the corresponding array
                                maneuverScores[maneuverType].push(parseFloat(score));
                            } else {
                                // If it doesn't exist, create a new array with the score as its first element
                                maneuverScores[maneuverType] = [parseFloat(score)];
                            }
                        }

                        // console.log("Latest five score ", latestScores);

                        Object.entries(maneuverScores).forEach(([key, value]) => {
                            // if (value.length < 5) {
                            //     let tempLength = 5 - value.length;
                            //     while (tempLength > 0) {
                            //         value.push(0);
                            //         tempLength--;
                            //     }
                            // }
                            seriesData.push({
                                name: key,
                                data: value
                            })
                        })
                        // seriesData = seriesData.sort((a, b) => a.startDate - b.startDate)
                        // console.log("Printing series data ", seriesData);
                        setSeriesData(seriesData);
                    });
                }

                // Set the latest scores state
                setLatestScores(latestScoresObject);
                // console.log("maneuver Score Array ", maneuverScoreArray);
                // console.log("Latest Score Object ", latestScoresObject);
            }
            bargraphArrayFunction();
            lineChartArrayFunction();
        }
    }


    useEffect(() => {
        const fetchData = () => {
            const dbRef = ref(db, Cookies.get('userId'));
            onValue(dbRef, (snapshot) => {
                const dataSet = snapshot.val();
                setData(dataSet);
                setProfileData(dataSet)
                setLoading(false);
                // console.log("printing data from database in performance", dataSet);
            });
        };
        fetchData();
    }, [loading]);



    useEffect(() => {
        // Initialize an object to store the latest scores for each maneuver type
        const bargraphArrayFunction = () => {
            const latestScoresObject = {};
            maneuverScoreArray = [];
            // Iterate over each maneuver type
            maneuverTypeArray.forEach(maneuverType => {
                // Filter journeys based on start date, end date, and maneuver type
                let filteredJourneys;
                if (data && Object.keys(data).length > 0) {
                    filteredJourneys = Object.values(data.journeys).filter(journey => (
                        // journey.startDate >= startDate &&
                        // journey.endDate <= endDate &&
                        // journey.journeyType === journeyType &&
                        journey.maneuverMeta.some(maneuver => maneuver.name === maneuverType)
                    ));
                    // console.log("filtered journey ", filteredJourneys);
                }


                // Sort filtered journeys based on start date in descending order
                filteredJourneys.sort((a, b) => b.startDate - a.startDate);

                // Get the latest journey (first one after sorting)
                const latestJourney = filteredJourneys[0];

                // console.log("Latest Journey ", latestJourney);

                // Initialize an array to store scores for the current maneuver type
                const scores = [];

                // Iterate over maneuver meta of the latest journey
                latestJourney?.maneuverMeta.forEach(maneuver => {
                    // Check if the maneuver type matches the specified maneuverType
                    if (maneuver.name === maneuverType) {
                        // Push the score to the scores array
                        maneuverScoreArray.push({ maneuverType: maneuverType, score: maneuver.quality.score ? maneuver.quality.score?.toFixed(2) : 0 });
                    }
                });

                // Add the maneuver type and its latest score to the latestScores object
                // maneuverScoreArray.push(scores);
                latestScoresObject[maneuverType] = scores;
                // console.log("Scores ", scores);

            });

            // Set the latest scores state
            setLatestScores(latestScoresObject);
            // console.log("maneuver Score Array ", maneuverScoreArray);
            let maneuverNameArr = [];
            let maneuverScoreArr = [];

            maneuverScoreArray.map((maneuver) => {
                maneuverNameArr.push(maneuver.maneuverType);
                maneuverScoreArr.push(maneuver.score);
            })

            setBarGraphJourneyobject({
                name: journeyType,
                categories: maneuverNameArr,
                data: maneuverScoreArr
            })
            // console.log("Printing maneuver score and maneuver type arr ", maneuverNameArr, " ", maneuverScoreArr);

            // console.log("Latest Score Object ", latestScoresObject);
        }
        const lineChartArrayFunction = () => {
            // console.log("Printing maneuver type array in use effect ", maneuverTypeArray);
            const latestScoresObject = {};
            maneuverScoreArray = [];
            // Iterate over each maneuver type
            maneuverTypeArray.forEach(maneuverType => {
                // Filter journeys based on start date, end date, and maneuver type
                let filteredJourneys;
                if (data && Object.keys(data).length > 0) {
                    filteredJourneys = Object.values(data.journeys).filter(journey => (
                        // journey.startDate >= startDate &&
                        // journey.endDate <= endDate &&
                        // journey.journeyType === journeyType && // Assuming you're interested only in ranked journeys
                        journey.maneuverMeta.some(maneuver => maneuver.name === maneuverType)
                    ));
                    // console.log("filtered journey ", filteredJourneys);
                }


                // Sort filtered journeys based on start date in descending order
                filteredJourneys?.sort((a, b) => b.startDate - a.startDate);

                // Get the latest journey (first one after sorting)
                const latestJourney = filteredJourneys?.slice(0, 5).sort((a, b) => a.startDate - b.startDate);


                // console.log("Latest Journey five ", maneuverType, " ", latestJourney);

                // Initialize an array to store scores for the current maneuver type
                const scores = [];

                // Iterate over maneuver meta of the latest journey
                if (latestJourney && latestJourney.length > 0) {
                    latestJourney?.map((item) => {
                        item.maneuverMeta.forEach(maneuver => {
                            if (maneuver.name === maneuverType) {
                                maneuverScoreArray.push({ maneuverType: maneuverType, score: maneuver.quality.score ? maneuver.quality.score?.toFixed(2) : 0 });
                            }
                        })
                    })
                }

                let seriesData = [];

                const maneuverScores = {};

                // Iterate through the maneuvers array
                for (const maneuver of maneuverScoreArray) {
                    const { maneuverType, score } = maneuver;

                    // Check if the maneuverType already exists as a key in the maneuverScores object
                    if (maneuverScores[maneuverType]) {
                        // If it exists, push the score to the corresponding array
                        maneuverScores[maneuverType].push(parseFloat(score));
                    } else {
                        // If it doesn't exist, create a new array with the score as its first element
                        maneuverScores[maneuverType] = [parseFloat(score)];
                    }
                }

                // console.log("Latest five score ", latestScores);

                Object.entries(maneuverScores).forEach(([key, value]) => {
                    // if (value.length < 5) {
                    //     let tempLength = 5 - value.length;
                    //     while (tempLength > 0) {
                    //         value.push(0);
                    //         tempLength--;
                    //     }
                    // }
                    seriesData.push({
                        name: key,
                        data: value
                    })
                })
                console.log("Printing series data ", seriesData);
                setSeriesData(seriesData);
            });

            // Set the latest scores state
            setLatestScores(latestScoresObject);
            // console.log("maneuver Score Array ", maneuverScoreArray);
            // console.log("Latest Score Object ", latestScoresObject);
        }
        bargraphArrayFunction();
        lineChartArrayFunction();
    }, [maneuverTypeArray]);

    useEffect(() => {
        const tempManeuverArray = [];
        const tempJourneyArray = [];
        if (data && Object.keys(data).length > 0) {
            Object.entries(data?.journeys).forEach(([key, value]) => {
                value?.activityTypes?.map((item) => {
                    if (!tempManeuverArray.includes(item)) {
                        // console.log("Printing maneuver type item ", item);
                        // setManeuverTypeArray(prevArray => [...prevArray, item]);
                        tempManeuverArray.push(item);
                    }
                })
                if (!tempJourneyArray.includes(value?.journeyType)) {
                    // setJourneyTypeArr(prevArray => [...prevArray, value?.journeyType]);
                    tempJourneyArray.push(value?.journeyType)
                }
            })
        }
        setManeuverTypeArray(tempManeuverArray);
        setJourneyTypeArr(tempJourneyArray);
    }, [data])


    let tempStartDate = startDate;
    let obj1 = {};


    const maneuverCallback = (maneuverAray) => {
        setManeuverDropdownArr(maneuverAray);
        // console.log("printing maneuver callback array ", maneuverAray)
    }

    const journeyCallback = (maneuverType) => {
        setJourneyType(maneuverType);
    }
    // console.log('printng maneuver type array ', maneuverTypeArray)

    useEffect(() => {
        if (!loading) {
            if (data) {
                const tempData = [];
                Object.entries(data?.journeys).forEach(([key, value]) => {
                    let obj = {};
                    obj.maneuverMeta = value.maneuverMeta;
                    const startDate = new Date(value.startDate);
                    // console.log("Date Value ", startDate);
                    obj.startDate = startDate
                    // console.log("New Object ", obj);
                    tempData.push(obj);
                })
                setManeuverData(tempData);
                // console.log("Priting maneuver ", maneuverData)
            }
        }
    }, [data])

    const performanceHeading = ["maneuver Date", "Score", "Altitude Variance", ""]
    return (
        <div>
            <div>
                <Navbar />
            </div>
            <div>

                {loading ? (
                    <div className="text-center mt-8 text-gray-500">Loading...</div>) :
                    data ? (
                        <div>
                            <div>
                                <h1 className='text-center text-2xl font-semibold mt-3 w-full'>
                                    My Performance Summary
                                </h1>
                            </div>
                            <div className='flex justify-evenly items-center bg-gray-800 mx-10 mt-4 py-1 '>
                                <div className='mr-2  lg:mr-20'>
                                    <MultiSelectDropDown maneuverType={"Maneuver Type"} maneuverTypeArray={maneuverTypeArray} maneuverCallback={maneuverCallback} isdropDownOpen={isDropDownOpen} setIsDropDownOpen={setIsDropDownOpen} />
                                </div>
                                <div className='mr-2 lg:mr-20 flex justify-between'>
                                    {/* <Dropdown data={"Date Range"} /> */}
                                    <div className='mr-20'>
                                        <DatePicker className="px-5  w-32 rounded-md py-2 " placeholderText="Start Date" selected={startDate} onChange={(date) => setStartDate(date.getTime())} maxDate={new Date()} />
                                    </div>
                                    <div className='ml-20'>
                                        <DatePicker className="px-5 w-32 rounded-md py-2 z-50" placeholderText="End Date" selected={endDate} onChange={(date) => chooseEndDate(date)} maxDate={new Date()} />
                                    </div>
                                </div>
                                <div className='mr-2 lg:mr-20'>
                                    <Dropdown journeyType={journeyType ? journeyType : "# Of Journey"} journeyTypeArr={journeyTypeArr} journeyCallback={journeyCallback} />
                                </div>
                                <div className='mt-2'>
                                    <button type="button" class="text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700 p-2  justify-center" onClick={() => handleSearch()}>Search</button>
                                </div>
                            </div>
                            <div className='flex flex-col lg:flex-row md:flex-row justify-evenly mt-12 mx-6'>
                                <div className='lg:w-1/2'>
                                    <BarGraph graphData={barGraphJourneyObject} />

                                </div>
                                <div className='lg:w-1/2 ml-3'>
                                    <LineChart data={seriesData} categories={categories} graphName="Score History" yAxisLabel="Maneuver Score" />
                                </div>
                            </div>
                            <div>
                                <div className='flex justify-between bg-gray-800 mt-4 p-3 text-white text-lg m-4  mx-2 lg:mx-10'>
                                    <div>
                                        <h1>Maneuver List</h1>
                                    </div>
                                </div>
                                <div className='mb-8 '>
                                    <div className="relative overflow-x-auto mx-2 lg:mx-10">
                                        <table className="w-full  text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 pr-32">
                                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                                <tr>
                                                    {performanceHeading.map((data) => {
                                                        return (
                                                            <th scope="col" className="px-6 text-center py-3 mx-auto">
                                                                {data}
                                                            </th>
                                                        )
                                                    })}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {maneuverData?.map((item) => {
                                                    return item.maneuverMeta.map((dataItem) => {
                                                        return (
                                                            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 mx-5">
                                                                <th
                                                                    scope="row"
                                                                    className="text-center mx-10 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                                                >
                                                                    {item.startDate.toLocaleDateString()}
                                                                </th>
                                                                <td className="px-6 text-center py-4">{dataItem.quality.score?.toFixed(2)}</td>
                                                                <td className="px-6 text-center mx-10 py-4">{dataItem.quality.alt_delta?.toFixed(2)}</td>
                                                                <td className="px-6 text-center mx-10 py-4 text-blue-500">
                                                                    <Link to='/performanceDetails'
                                                                        state={{
                                                                            id: dataItem.id,
                                                                            maneuverArray: data.maneuvers,
                                                                            maneuverName: dataItem.name
                                                                        }}>View Details</Link>
                                                                </td>
                                                            </tr>
                                                        );
                                                    });
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>) : (
                        <div style={{ marginTop: "250px" }} className='flex items-center justify-center h-full text-center text-3xl pt-50'>
                            No Data Available
                        </div>
                    )}
            </div>
        </div>
    )
}

export default Performance